const loopMap = require('mn-utils/loopMap');
const {
  apiRequestAdmin,
} = require('../ws');

import {
  ENDPOINT_ADMIN_ACC_LIST,
  ENDPOINT_ADMIN_ACC_SUBMERCHANT_CREATE, ENDPOINT_ADMIN_ACC_SUBMERCHANT_UPDATE
} from '../../constants/api';

const MOCK_ACCOUNTS = loopMap(100, (i) => ({
  id: '98690198-98bc-421a-ace4-e2fe5dd590eb' + i,
  company: 'Lunu Solution GmbH',
  login: 'Pavlo Denysuk',
  user_role: 'merchant', // eslint-disable-line
  lifeflow: 'ready',
  blocked: false,
}));

export function apiAdminAccountsList(params) {
  params = params || {};
  const offset = params.offset || 0;
  const limit = params.limit || 50;
  return apiRequestAdmin(ENDPOINT_ADMIN_ACC_LIST, {
    ...params,
    offset,
    limit,
  }, () => {
    return {
      list: MOCK_ACCOUNTS.slice(offset, offset + limit),
      count: MOCK_ACCOUNTS.length,
    };
  });
}

export function apiAdminAccountsSubmerchantCreate(accountID) {
  return apiRequestAdmin(ENDPOINT_ADMIN_ACC_SUBMERCHANT_CREATE, {
    account_id: accountID,
  });
}
export function apiAdminAccountsSubmerchantUpdate(accountID) {
  return apiRequestAdmin(ENDPOINT_ADMIN_ACC_SUBMERCHANT_UPDATE, {
    account_id: accountID,
  });
}
